import axios, { AxiosResponse, AxiosError } from 'axios';

import { remountApp } from '..';

export const attachTokenToHeader = (token: string) => {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const detachTokenFromHeader = () => {
  delete axios.defaults.headers.common.Authorization;
};

export const setUpAxiosInterceptors = () => {
  const onFulfilled = (response: AxiosResponse) => {
    return response;
  };

  const onRejected = (error: AxiosError) => {
    if (error.message === 'Network Error') {
      return;
    }

    const response = error.response;
    if (response) {
      // unhandle in fe for response.data.status === 404
      const notAccess = response.data.status === 401 || response.data.status === 403 || response.data.message === "Token has expired";
      if (notAccess) {
        localStorage.removeItem('token');
        remountApp();
      }
    }

    return Promise.reject(response);
  };

  axios.interceptors.response.use(onFulfilled, onRejected);
};
